import React from "react";
import { observer, inject } from "mobx-react";
import { SelectField } from "ComponentsUI/Selectfield";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import { withRouter } from "react-router-dom";
import FiltersLoadParams from "HOC/FiltersLoadParams";
import withDefaultParams from "Services/withDefaultParams";
import { variablesFromRouter } from "Services/QueryBuilder";
import { FiltersStub } from "Layouts/Stubs";
import { FILTERS_TARIFFS_ADDRESS_QUERY } from "Services/queries";
import { graphql } from "@apollo/client/react/hoc";
import queryString from "query-string";
import Metrika from "Services/Metrika";
import { EVENT_CATEGORY_FILTER_DATA } from "Constants/metriks/GoogleCategorys";

@inject("ApplicationModel")
@observer
class FilterProviders extends FiltersLoadParams {
	constructor(props) {
		super(props);
		this.state = {
			revertSpeed: false,
			showFilters: false,
			requireUpdate: false,
		};
	}

	onFilter(filter) {
		const {
			match: { params },
			location: { search },
			history,
		} = this.props;
		let getParams = queryString.parse(search);
		let filterArr = [];
		let selectedProviders = [];

		if (filter.house_id) {
			getParams = {};
			getParams.house_id = filter.house_id;
		}

		if (filter.providers) {
			filter.providers.map((item) => {
				selectedProviders.push(item.id);
			});
			getParams.providers = selectedProviders.join(",");
		}

		for (let key in getParams) {
			if (getParams[key]) {
				filterArr.push(`${key}=${getParams[key]}`);
			}
		}

		const ratesUrl = this.props.new_house_url
			? generateUrl(Routes.RatesInHouse.route, {
					regionUrl: params.regionUrl,
					house_url: params.house_url,
					house_id: params.house_id,
				})
			: generateUrl(Routes.DomaNzl.route, {
					regionUrl: params.regionUrl,
				});

		Metrika.getInstance().google.sendEvent(
			EVENT_CATEGORY_FILTER_DATA,
			`filter_data.tariffs.${filterArr.join("&")}`
		);

		history.push({
			pathname: ratesUrl,
			search: `?${filterArr.join("&")}`,
		});
	}

	componentWillUnmount() {
		let { ApplicationModel } = this.props;
		ApplicationModel.setRatesFromMainPage(false);
	}

	componentDidMount() {
		let { ApplicationModel, aggregation } = this.props;
		ApplicationModel.setRatesFromMainPage(true);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		let {
			ApplicationModel: { providerModel },
			aggregation,
		} = this.props;
	}

	render() {
		let {
			ApplicationModel: {
				text,
				windowSizeModel: { windowSizes },
			},
			aggregation,
		} = this.props;

		if (!aggregation) {
			return <FiltersStub amount={1} sort={true} withoutSwitchers={true} />;
		}

		const providers = aggregation.providers;
		const providersFound = this.providersInitFromGetParams(providers);

		return (
			<SelectField
				centering={this.props.centering}
				placeholder={text.CHOOSE_PROVIDER}
				activePlaceHolder={text.CHOOSE_PROVIDER}
				multiselect={false}
				windowSizes={windowSizes}
				items={providers}
				onItemSelect={(items) =>
					this.onFilter({
						providers: items,
					})
				}
				text={text}
				findItems={providersFound}
				inputName="change_providers"
			/>
		);
	}
}

export default withRouter(
	withDefaultParams(
		variablesFromRouter(
			graphql(FILTERS_TARIFFS_ADDRESS_QUERY, {
				skip: (props) => {
					return !props.house_id;
				},
				options: (props) => {
					return {
						variables: {
							houseId: props.house_id,
						},
					};
				},
				props: ({ ownProps, data }) => {
					if (data.filtersTariffsAddress) {
						return { aggregation: data.filtersTariffsAddress };
					}
					return null;
				},
			})(FilterProviders)
		)
	)
);
